import type { PurchasingPhase } from '@b-stock/fe-core/bstock-next/helpers'

import { getUserMinBidAmount } from '@/helpers/getUserMinBidAmount'
import type { CombinedListingSearchResult } from '@/queries/CombinedListingSearchResult'

export const getMinBidAmount = (
  listing: CombinedListingSearchResult,
  activePhase: PurchasingPhase | null
) => {
  const {
    bidAmount,
    bidPrecision,
    buyNowPrice,
    nextMinBidAmount,
    startPrice,
    winningBidAmount,
  } = listing

  if (activePhase === 'BINO' && buyNowPrice) return buyNowPrice

  return getUserMinBidAmount({
    bidAmount,
    bidPrecision,
    nextMinBidAmount,
    startPrice,
    winningBidAmount,
  })
}
